exports.getAllParams = (key, { pathname } = {}) => {
  if (pathname && pathname !== window.location.pathname) {
    return [];
  }
  return new URLSearchParams(window.location.search).getAll(key) || [];
};
